/**
 * Cleans and maps a given tier to a standardized tier.
 * @function getCleanedTier
 * @param {string | undefined} tier - The tier to clean and map.
 * @returns {string} The cleaned and mapped tier.
 */
export const getCleanedTier = (tier: string | undefined): string => {
  const cleanedTier = tier?.toLowerCase().trim();

  switch (cleanedTier) {
    case 'very common':
      return 'essential';
    case 'essential':
      return 'essential';
    case 'utility':
      return 'essential';
    case 'core':
      return 'exclusive';
    case 'exclusive':
      return 'exclusive';
    case 'unique':
      return 'exclusive';
    case 'common':
      return 'exclusive';
    case 'grail':
      return 'grail';
    case 'rare':
      return 'grail';
    case '1:1':
      return 'iconic';
    case 'iconic':
      return 'iconic';
    case 'limited':
      return 'iconic';
    case 'custom':
      return 'iconic';
    default:
      return 'essential';
  }
};

/**
 * Gets the background style class for a given rarity.
 * @function getBackgroundRarityStyle
 * @param {string | undefined} rarity - The rarity to get the background style for.
 * @returns {string} The background style class.
 */
export const getBackgroundRarityStyle = (
  rarity: string | undefined,
): string => {
  const cleanedRarity = getCleanedTier(rarity);

  switch (cleanedRarity) {
    case 'exclusive':
      return 'bg-exclusive';
    case 'grail':
      return 'bg-grail';
    case 'iconic':
      return 'bg-one-of-one';
    case 'essential':
      return 'bg-white';
    default:
      return 'bg-white';
  }
};

/**
 * Gets the text style class for a given rarity.
 * @function getTextRarityClass
 * @param {string} rarity - The rarity to get the text style for.
 * @returns {string} The text style class.
 */
export const getTextRarityClass = (rarity: string): string => {
  const cleanedRarity = getCleanedTier(rarity);

  switch (cleanedRarity) {
    case 'exclusive':
      return 'text-[#7DAFFF]';
    case 'grail':
      return 'bg-grail bg-clip-text text-transparent';
    case 'iconic':
      return 'bg-one-of-one bg-clip-text text-transparent';
    case 'essential':
      return 'text-mushroom-300';
    default:
      return 'text-mushroom-300';
  }
};
